export var noop = function noop() {};
export var toArray = function toArray(value) {
  value = value || [];
  return Array.isArray(value) ? value : [value];
};